/**
 * TEMPORARY PRODUCT SURFACE LOCK
 *
 * This is the single source of truth for the reversible product lock described
 * in `FEATURE_LOCKS.md`. Do not delete the locked pages or their preserved
 * Sidebar branches while this is enabled. The user intends to restore them.
 *
 * Developer access is intentionally exposed through the browser-console
 * `lock` variable. Setting `lock = false` stores the console override cookie;
 * setting `lock = true` removes it. There is no URL/query-string bypass.
 */
export const PRODUCT_SURFACE_LOCK_ENABLED = true;

export const PRODUCT_SURFACE_LOCK_FALLBACK_PATH = "/ah/risk-assessment";
export const PRODUCT_SURFACE_LOCK_COOKIE_NAME = "seexr_product_lock";
export const PRODUCT_SURFACE_LOCK_UNLOCK_VALUE = "false";

const LOCKED_ROUTE_PREFIXES = ["/c", "/chat"] as const;

/**
 * /artifacts/** (Library) and /projects/** stay accessible while locked.
 * `/` is the legacy new-chat entry and is exact-match only. The remaining
 * entries include all descendants so stale bookmarks cannot bypass the lock.
 */
export function isProductSurfaceLockActive(cookieValue?: string): boolean {
  return (
    PRODUCT_SURFACE_LOCK_ENABLED &&
    cookieValue !== PRODUCT_SURFACE_LOCK_UNLOCK_VALUE
  );
}

export function readProductSurfaceLockCookie(
  cookieHeader: string,
): string | undefined {
  const prefix = `${PRODUCT_SURFACE_LOCK_COOKIE_NAME}=`;
  const match = cookieHeader
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix));

  return match?.slice(prefix.length);
}

export function isTemporarilyLockedProductPath(
  pathname: string,
  cookieValue?: string,
): boolean {
  if (!isProductSurfaceLockActive(cookieValue)) return false;
  if (pathname === "/") return true;

  return LOCKED_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
